import React from 'react';
import { colors } from 'styleguide';

import { IconProps } from './types';

export const LinkClosed = ({ size = 20, color = colors('neutral', 2) }: IconProps) => (
  <svg width={size} height={size} viewBox="0 0 7 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1.33203 3.58126V2.3654C1.36696 1.7436 1.88537 0.5 3.67965 0.5C5.47394 0.5 5.99238 1.7436 6.02731 2.3654V7.08177C6.02731 7.71061 5.55775 8.88443 3.67965 8.88443H3.54794"
      stroke={color}
      strokeLinecap="square"
    />
    <path
      d="M6.02734 10.4984V11.6346C5.99242 12.2564 5.474 13.5 3.67972 13.5C1.88544 13.5 1.367 12.2564 1.33206 11.6346V6.91823C1.33206 6.28939 1.80162 5.11557 3.67972 5.11557H3.88933"
      stroke={color}
      strokeLinecap="square"
    />
  </svg>
);
